import { Text } from '@mantine/core';
import { formatCascade, type PayoutCascade } from '~/entities/payout';
import { type TableCell, type TableData, type TableRow } from '~/shared/ui/Table';

const prepareHeaders: TableCell[] = [
    { key: 'id', content: 'ID', ta: 'center' },
    { key: 'name', content: 'Название', ta: 'center' },
    { key: 'queueLength', content: 'Кол-во элементов очереди', ta: 'center' },
    { key: 'currency', content: 'Валюта', ta: 'center' },
    { key: 'requisiteType', content: 'Реквизит', ta: 'center' },
];

type PrepareTableDataProps = {
    cascades?: PayoutCascade[];
};

const prepareRows = ({ cascades }: PrepareTableDataProps): TableRow<PayoutCascade>[] => {
    if (!cascades) {
        return [];
    }

    return cascades.map((cascade) => ({
        key: cascade.id?.value ?? 0,
        cells: [
            { key: 'id', content: <Text ta='center'>{cascade.id?.value}</Text> },
            { key: 'name', content: <Text ta='center'>{cascade.name?.value}</Text> },
            { key: 'queueLength', content: <Text ta='center'>{cascade.queueItems?.length ?? 0}</Text> },
            { key: 'currency', content: <Text ta='center'>{formatCascade.currency(cascade.filter?.currency)}</Text> },
            {
                key: 'requisiteType',
                content: <Text ta='center'>{formatCascade.requisiteType(cascade.filter?.requisiteType)}</Text>,
            },
        ],
        item: cascade,
    }));
};

export const createTableData = ({ cascades }: PrepareTableDataProps): TableData<PayoutCascade> => {
    return {
        head: prepareHeaders,
        rows: prepareRows({ cascades }),
        caption: cascades?.length === 0 ? 'Каскадов нет' : undefined,
    };
};
